import axios from "axios";
import { createBrowserHistory } from 'history';
import { message } from "antd";
import { BaseUrl } from "./urls";

const axiosInstance = axios.create({
    baseURL: BaseUrl,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 10000,
});

const history = createBrowserHistory();

// Add request interceptor to attach Bearer token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ses_access_token'); // Get the token from localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Attach the token in Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 Unauthorized errors
axiosInstance.interceptors.response.use(
  (response) => response, // Return response if status is 200
  (error) => {
    if (error.response?.status === 401) {
      // If 401 is returned, redirect to login page
      message.error('Session expired. Please log in again.');
      history.push('/login');
      window.location.reload(); // Reload the page to ensure the login page loads properly
    }
    return Promise.reject(error); // Reject the promise for other errors
  }
);

export default axiosInstance;
